import { v4 as uuidV4 } from 'uuid';
const mockTeamNamesAlpha = [
    'charming',
    'sneaky',
    'cynical',
    'evangelical',
    'awesome',
    'reptilian',
    'amorphous',
    'clerical',
    'deterministic',
    'heinous',
] as const;
const mockTeamNamesBeta = [
    'turtles',
    'orcas',
    'lions',
    'bears',
    'sea-lions',
    'meerkats',
    'warthogs',
    'whales',
    'eagles',
    'hummingbirds',
] as const;

function semiRandNum(): number {
    let uIdNum: string = uuidV4().replace(/[^\d]/g, ''); // replace all non nums with an empty string
    if (uIdNum.length > 2) {
        uIdNum = uIdNum.slice(0, 2);
    }
    let isoNum = Date.now().toString();
    isoNum = isoNum.slice(isoNum.length - 2, isoNum.length);
    if (parseInt(isoNum.charAt(0), 10) % 2 === 0) {
        return parseInt(`${uIdNum.charAt(0)}${isoNum.charAt(1)}`, 10) * Math.random();
    } else {
        return parseInt(`${isoNum.charAt(0)}${uIdNum.charAt(1)}`, 10) * Math.random();
    }
}

export function mockTeamName() {
    const isEvenTimestamp = Date.now() % 2 === 0;
    const roundFn = isEvenTimestamp ? Math.floor : Math.ceil;
    const indexA = roundFn(semiRandNum() / 10);
    const indexB = roundFn(semiRandNum() / 10);
    return `${mockTeamNamesAlpha[isEvenTimestamp ? indexA : indexB]} ${
        mockTeamNamesBeta[isEvenTimestamp ? indexB : indexA]
    }`;
}
